module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": _vm.item.id + 'LineitemContainer'
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "p-r-15"
  }, [_c('div', {
    staticStyle: {
      "border": "1px solid grey",
      "padding": "10px",
      "background": "white",
      "margin-bottom": "20px"
    }
  }, [_c('div', [_vm._v("Type: " + _vm._s(_vm.item.type))]), _vm._v(" "), _c('div', [_vm._v("\n                    Line item Id :\n                    "), _c('span', [_vm._v(_vm._s(_vm.item.xid))])]), _vm._v(" "), _c('div', [_vm._v("\n                    Size :\n                    "), _vm._l((_vm.item.dimensions), function(dimension, index) {
    return _c('span', {
      key: dimension.id
    }, [(_vm.dimensions.length && index + 1 == _vm.item.dimensions.length) ? _c('span', [_vm._v(_vm._s(_vm.dimensions.filter(function (k) { return k.id == dimension; })[0].width +
      'X' +
      _vm.dimensions.filter(function (k) { return k.id == dimension; })[0].height))]) : (_vm.dimensions.length) ? _c('span', [_vm._v(_vm._s(_vm.dimensions.filter(function (k) { return k.id == dimension; })[0].width +
      'X' +
      _vm.dimensions.filter(function (k) { return k.id == dimension; })[0].height +
      ' , '))]) : _vm._e()])
  })], 2), _vm._v(" "), _c('div', [_vm._v("\n                    Device :\n                    "), _vm._l((_vm.item.device), function(dev, index) {
    return _c('span', {
      key: index
    }, [(index + 1 == _vm.item.device.length) ? _c('span', [_vm._v(_vm._s(_vm.devices.length && _vm.devices.filter(function (k) { return k.id == dev; })[0].name))]) : _c('span', [_vm._v(_vm._s(_vm.devices.length && _vm.devices.filter(function (k) { return k.id == dev; })[0].name + ' , '))])])
  })], 2), _vm._v(" "), (_vm.item.type !== 'unitag') ? _c('div', [_vm._v("\n                    Placements :\n                    "), (_vm.item.placement_text && _vm.item.placement_text.length) ? _c('ol', {
    staticStyle: {
      "margin": "0"
    }
  }, _vm._l((_vm.changeItemFormat(_vm.item.placement_text[0])), function(divt, index) {
    return _c('li', {
      key: index
    }, [(divt.data && divt.operator) ? _c('span', [_c('span', {
      staticClass: "p-l-20"
    }, [_vm._v(_vm._s(index + 1) + ". Operator:\n                                    " + _vm._s(divt.hasOwnProperty('operator') && divt.operator) + " , Value:\n                                    " + _vm._s(divt.data ? divt.data : divt))])]) : _vm._e()])
  }), 0) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', [_vm._v("\n                    Position :\n                    "), (_vm.item.positions && _vm.item.positions.length) ? _c('ol', {
    staticStyle: {
      "margin": "0"
    }
  }, _vm._l((_vm.changeItemFormat(_vm.item.positions)), function(divt, index) {
    return _c('li', {
      key: index
    }, [(divt.data && divt.operator) ? _c('span', [_c('span', {
      staticClass: "p-l-20"
    }, [_vm._v(_vm._s(index + 1) + ". Operator:\n                                    " + _vm._s(divt.hasOwnProperty('operator') && divt.operator) + " , Value:\n                                    " + _vm._s(divt.data ? divt.data : divt))])]) : _vm._e()])
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', [_vm._v("\n                    Browser :\n                    "), _vm._l((_vm.item.browsers), function(browser, index) {
    return (_vm.browsers && _vm.browsers.length) ? _c('span', {
      key: index
    }, [(index + 1 == _vm.item.browsers.length) ? _c('span', [_vm._v(_vm._s(_vm.browsers.filter(function (k) { return k.id == browser; })[0].name))]) : _c('span', [_vm._v(_vm._s(_vm.browsers.filter(function (k) { return k.id == browser; })[0].name + ' , '))])]) : _vm._e()
  })], 2), _vm._v(" "), _c('div', [_vm._v("\n                    Geo :\n                    "), _vm._l((_vm.item.country), function(con, index) {
    return (_vm.countries && _vm.countries.length) ? _c('span', {
      key: index
    }, [(index + 1 == _vm.item.country.length) ? _c('span', [_vm._v(_vm._s(_vm.countries.filter(function (k) { return k.id == con; })[0].code))]) : _c('span', [_vm._v(_vm._s(_vm.countries.filter(function (k) { return k.id == con; })[0].code + ' , '))])]) : _vm._e()
  })], 2), _vm._v(" "), _c('div', [_vm._v("\n                    Revenue Channels :\n\n                    "), _vm._l((_vm.item.revenue_channel), function(revenue_channel) {
    return _c('ol', {
      staticClass: "p-l-20"
    }, [_c('li', [_c('span', [_vm._v(" " + _vm._s(revenue_channel.type) + ": " + _vm._s(revenue_channel.name) + " ")])])])
  })], 2), _vm._v(" "), _c('div', [_vm._v("\n                    Creative :\n                    "), (_vm.creativeList && _vm.creativeList.length) ? _c('ol', {
    staticClass: "p-l-20"
  }, _vm._l((_vm.item.creative), function(creative, id) {
    return _c('li', {
      key: id
    }, [_vm._v("\n                            " + _vm._s(id + 1) + ". Name: " + _vm._s(_vm.creativeList.filter(function (k) { return k.id == creative; })[0].name) + ", Sib Id:\n                            " + _vm._s(_vm.creativeList.filter(function (k) { return k.id == creative; })[0].sib_id) + "\n                        ")])
  }), 0) : _vm._e()])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bc5cf636!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/admin/AdspotDetails.vue
// module id = 720
// module chunks = 2